module.exports = __webpack_public_path__ + "img/orange_030.8dd717bd.png";